export default {
  namespaced: true,
  state: {
    isLoggedIn: false,
    user: {}
  },
  getters: {
    isLoggedIn (state) {
      return state.isLoggedIn
    },
    user (state) {
      return state.user
    }
  },
  actions: {
    updateIsLoggedIn (state, isLoggedIn) {
      state.commit('updateIsLoggedIn', isLoggedIn)
    },
    updateUser (state, user) {
      state.commit('updateUser', user)
    }
  },
  mutations: {
    updateIsLoggedIn (state, isLoggedIn) {
      state.isLoggedIn = isLoggedIn
    },
    updateUser (state, user) {
      state.user = user
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/auth/store.js